var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFileSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attach_file",
    transform: "translate(-7 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M16.5,6V17.5a4,4,0,0,1-8,0V5a2.5,2.5,0,1,1,5,0V15.5a1,1,0,0,1-2,0V6H10v9.5a2.5,2.5,0,0,0,5,0V5A4,4,0,0,0,7,5V17.5a5.5,5.5,0,0,0,11,0V6Z",
    fill: "#00246A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFileSms);
export default __webpack_public_path__ + "static/media/attach_fileSMS.ab0f27ba3ff69a89288fb73e6fcb942a.svg";
export { ForwardRef as ReactComponent };